export default __webpack_public_path__ + "static/media/photo-4@2x.133391ac.png";